const RailOfFutureSection = () => {
  return (
    <section id="rail-of-future" className="w-full flex justify-center">
      <div
        data-aos="fade-up"
        className="w-4/5 max-w-screen-xl flex justify-center flex-col pt-28 pb-16 "
      >
        <div>
          <h3 className="text-5xl sm:text-7xl text-custom-red font-bold pb-8">
            Geleceğin Ray’ında
            <br />
            Nedir?
          </h3>
        </div>
        <div className="flex flex-col space-y-20">
          <div className="w-5/6">
            <p className="font-normal text-md sm:text-xl ">
              Geleceğin Ray’ında Genç Yetenek Programı, yeni nesil
              yetkinliklerini ve yeteneklerini keşfetmeni sağlayacak, akademik
              bilgilerini uygulama fırsatı sunacak, mezuniyetin sonrası
              sigortacılık sektöründe sağlam bir kariyerin temellerini
              oluşturmana eşlik edecek bir genç yetenek programıdır.
            </p>
          </div>
          <div className="flex flex-col space-y-3">
            <div className="w-full flex flex-col md:flex-row border border-black">
              <div className="w-full md:w-1/3 text-3xl text-white px-5 py-3 font-extrabold  bg-custom-red">
                Program Süresi:
              </div>
              <div className="flex items-center px-5 py-3 sm:border-l border-black">
                <p>1 Yıl*</p>
              </div>
            </div>
            <div className="w-full">
              *Belirsiz süreli iş sözleşmesi yapılacaktır
            </div>
            <div className="w-full flex flex-col md:flex-row border border-black">
              <div className="w-full md:w-1/3 text-3xl text-white px-5 py-3 font-extrabold bg-custom-red">
                Departmanlar:
              </div>
              <div className="flex items-center px-5 py-3 sm:border-l border-black">
                <p>
                  Mali İşler, Hasar, Bilgi Teknolojileri, İş Zekası, Proje
                  Yönetimi, Teknik
                </p>
              </div>
            </div>
            <div className="w-full flex flex-col md:flex-row border border-black">
              <div className="w-full md:w-1/3 text-3xl text-white px-5 py-3 font-extrabold bg-custom-red">
                Rotasyon:
              </div>
              <div className="flex items-center px-5 py-3 sm:border-l border-black">
                <p>
                  6 aylık süreç sonrası yukarıdaki departmanlar arasında
                  rotasyon yapabilirsin.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RailOfFutureSection;
